// extracted by mini-css-extract-plugin
module.exports = {"clickableArea":"clickableArea--ae9e7"};